import { usePopup } from '@/compositions/popup/index.ts';
import { computed } from '@vue/composition-api';
import { abcSort } from '@/compositions/sortBy';
import { useCopy } from '@/compositions/copy';
import ObjectGroupService from '@/modules/object-groups/api/object-group';
import { useI18n } from 'vue-i18n-bridge';
import messages from '@/layouts/menu/menu.i18n.json';
import { useSnackBar } from '@/compositions/snackBar';
import router from '@/router';

export default function(items) {
  const popup = usePopup();
  const { copyWithAlert } = useCopy();
  const { show } = useSnackBar();
  const { t } = useI18n({
    messages,
    inheritLocale: true,
    useScope: 'local'
  });

  const titleWithCount = (objects = [], name) => `${name} (${objects.length})`;

  const addObjectGroupItem = {
    id: 'add_objectgroup',
    title: t('Add group'),
    icon: '$add',
    action: () => {
      popup.open({
        component: () =>
          import('@/modules/object-groups/ui/ObjectGroupCreate.vue')
      });
    }
  };
  return {
    items: computed(() => [
      ...[...items.value]
        .sort((a, b) => abcSort(a.name, b.name))
        .map(({ id, name, objectsWithinGroup }) => ({
          id,
          title: titleWithCount(objectsWithinGroup, name),
          type: 'MenuItemDefault',
          useDropdownActions: true,
          to: {
            name: 'objects',
            params: {
              groupId: id
            }
          },
          actions: [
            {
              id: 'edit',
              icon: '$edit',
              title: t('Edit'),
              action: () => {
                popup.open({
                  component: () =>
                    import('@/modules/object-groups/ui/ObjectGroupEdit.vue'),
                  props: { id: id }
                });
              }
            },
            {
              id: 'copy',
              icon: '$copy',
              title: t('Copy UUID'),
              action: () => {
                copyWithAlert(JSON.stringify(id));
              }
            },
            {
              id: 'delete',
              icon: '$delete',
              title: t('Delete'),
              action: () => {
                popup.openConfirm({
                  component: () =>
                    import('@/components/popup/PopupConfirmActionNegative.vue'),
                  props: {
                    title: t('Delete object group?'),
                    onConfirm: async () => {
                      await ObjectGroupService.delete(id);
                      show(t('Deleted successfully'));
                      await router.push({ name: 'objects' }).catch(() => {});
                    }
                  }
                });
              }
            }
          ]
        })),
      addObjectGroupItem
    ])
  };
}
